import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function DayTimeline() {
  const timelineEvents = [{
    time: '6:30-8:30am',
    title: 'Drop-off + breakfast',
    photoSrc: 'https://cdn.magicpatterns.com/uploads/qoZ6jM3fKXWK3u4d1KwCec/shot-of-a-teacher-singing-with-her-preschool-children.jpg',
    alt: 'Children having breakfast at Funtastic Kidz Early Learning Centre Wyndham Vale',
    color: 'bg-blue',
    borderColor: 'border-blue'
  }, {
    time: '8:30-10:00am',
    title: 'Outdoor play + morning learning',
    photoSrc: 'https://cdn.magicpatterns.com/uploads/kEJPbWkajEwcVMRKQddBhV/children-playing-together-in-the-classroom-in-kindergarten-.jpg',
    alt: 'Children at outdoor play at Funtastic Kidz Early Learning Centre Wyndham Vale',
    color: 'bg-coral',
    borderColor: 'border-coral'
  }, {
    time: '10:00-11:00am',
    title: 'Program-specific learning',
    photoSrc: 'https://cdn.magicpatterns.com/uploads/cgkdVezvMH87xH8pYRd5CT/kid-is-learning-in-class.jpg',
    alt: 'Children engaged in classroom learning at Funtastic Kidz Early Learning Centre Wyndham Vale',
    color: 'bg-teal',
    borderColor: 'border-teal'
  }, {
    time: '11:00am-12:30pm',
    title: 'Lunch + rest',
    photoSrc: 'https://cdn.magicpatterns.com/uploads/cpvEPqgrngxUYT2o3QmMvj/nursery-children-playing-with-teacher-in-the-classroom.jpg',
    alt: 'Children having lunch at Funtastic Kidz Early Learning Centre Wyndham Vale',
    color: 'bg-yellow',
    borderColor: 'border-yellow'
  }, {
    time: '12:30-3:00pm',
    title: 'Quiet rest, then afternoon programs',
    photoSrc: 'https://cdn.magicpatterns.com/uploads/i93NFP9TDRpFm3tk93ov5M/creative-kids-posing.jpg',
    alt: 'Children resting at Funtastic Kidz Early Learning Centre Wyndham Vale',
    color: 'bg-blue',
    borderColor: 'border-blue'
  }, {
    time: '3:00-6:30pm',
    title: 'Afternoon tea, free play, family pickup',
    photoSrc: 'https://cdn.magicpatterns.com/uploads/qoZ6jM3fKXWK3u4d1KwCec/shot-of-a-teacher-singing-with-her-preschool-children.jpg',
    alt: 'Parent picking up child at Funtastic Kidz Early Learning Centre Wyndham Vale',
    color: 'bg-coral',
    borderColor: 'border-coral'
  }];
  return <section className="py-20 md:py-32 px-6 bg-cream relative overflow-hidden" data-id="element-93">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-94">
        <div className="text-center mb-20" data-id="element-95">
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy mb-6 tracking-tight" data-id="element-96">
            A day at Funtastic Kidz.
          </h2>
          <p className="text-lg md:text-xl text-navy/70 font-medium" data-id="element-97">
            What your child experiences from drop-off to pick-up.
          </p>
        </div>

        <div className="relative" data-id="element-98">
          {/* Central Line */}
          <div className="absolute left-[28px] md:left-1/2 top-0 bottom-0 w-1 bg-sand/50 md:-translate-x-1/2 rounded-full" data-id="element-99"></div>

          <div className="space-y-12" data-id="element-100">
            {timelineEvents.map((event, index) => <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} key={index} className={`relative flex flex-col md:flex-row items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-101">
                {/* Timeline Dot */}
                <div className={`absolute left-[16px] md:left-1/2 w-7 h-7 rounded-full ${event.color} border-4 border-cream shadow-md z-10 md:-translate-x-1/2`} data-id="element-102"></div>

                {/* Content Box */}
                <div className={`w-full md:w-1/2 pl-20 md:pl-0 ${index % 2 === 0 ? 'md:pr-16 text-left md:text-right' : 'md:pl-16 text-left'}`} data-id="element-103">
                  <div className={`bg-white p-6 md:p-8 rounded-[24px] shadow-sm hover:shadow-md transition-shadow border-t-4 ${event.borderColor}`} data-id="element-104">
                    <div className={`font-extrabold text-sm mb-3 uppercase tracking-wider ${event.color.replace('bg-', 'text-')}`} data-id="element-105">
                      {event.time}
                    </div>
                    <h3 className="text-xl font-extrabold text-navy mb-4" data-id="element-106">
                      {event.title}
                    </h3>
                    <div className="aspect-[16/9] bg-sand/30 rounded-xl flex items-center justify-center overflow-hidden relative border border-sand/50 group" data-id="element-107">
                      <img src={event.photoSrc} alt={event.alt} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-108" />
                      <div className="absolute inset-0 bg-cream/5 mix-blend-overlay" data-id="element-109"></div>
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}